var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00732422H513V341.959H0V-0.00732422Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 -0.00732422V117.622H210.31L256.5 148.382V171.026H233.856L160.312 122.031V171.026H96.1875V122.031L22.6441 171.026H0V148.382L46.19 117.622H0V53.497H46.19L0 22.737V-0.00732422H22.6441L96.1875 48.9882V-0.00732422H160.312V48.9882L233.856 -0.00732422H256.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.281 -0.00732422H112.219V69.5282H0V101.591H112.219V171.026H144.281V101.591H256.5V69.5282H144.281V-0.00732422Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00732422V15.1222L57.5121 53.497H80.1562L0 -0.00732422ZM256.5 -0.00732422V15.1222L198.988 53.497H176.344L256.5 -0.00732422Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 22.7371V53.497H210.31L256.5 22.7371Z",
    fill: "#2E52B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00732422V15.1222L57.5121 53.497H80.1562L0 -0.00732422ZM256.5 -0.00732422V15.1222L198.988 53.497H176.344L256.5 -0.00732422Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 22.7371V53.497H210.31L256.5 22.7371Z",
    fill: "#2E52B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 171.026V155.897L57.5121 117.622H80.1562L0 171.026ZM256.5 171.026V155.897L198.988 117.622H176.344L256.5 171.026Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.877 139.966C449.777 184.452 442.663 232.245 384.75 255.09C326.837 232.245 319.723 184.452 319.623 139.966H449.877Z",
    fill: "#29DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.877 139.966C449.877 123.233 448.975 107.001 449.376 92.7735C427.734 83.1548 399.178 81.1509 384.65 81.1509C370.122 81.1509 341.666 83.1548 319.924 92.7735C320.325 107.001 319.423 123.233 319.423 139.966H449.877Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.221 204.892L370.522 215.212L357.697 215.413L362.607 228.638H345.273C327.238 208.399 321.827 186.156 320.324 160.405L329.442 150.687L337.758 165.014L348.579 152.189L355.593 160.005L356.395 175.735L370.221 204.892Z",
    fill: "#BF521B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.453 192.869L428.836 211.204H381.744L352.487 191.666L378.238 202.187H403.387L407.094 195.674L414.308 195.874L416.312 192.869H437.453Z",
    fill: "#474747"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_376"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 341.967,
    fill: "white",
    transform: "translate(0 -0.00732422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSh);
export default __webpack_public_path__ + "static/media/SH.df3f4775c91394f776e4d22708010abd.svg";
export { ForwardRef as ReactComponent };